import { Toaster } from "@/components/ui/toaster.tsx";
import { AuthProvider } from "@/context/auth/AuthProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import { TooltipProvider } from "./components/ui/tooltip";
import { LastTimeNewOrdersCheckedProvider } from "./context/OrderContext";
import { AppRouter } from "./pages/routes";
import i18n from "./i18n";

const queryClient = new QueryClient();

i18n.init();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LastTimeNewOrdersCheckedProvider>
          <TooltipProvider>
            <AppRouter />
            <Toaster />
          </TooltipProvider>
        </LastTimeNewOrdersCheckedProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
